import React, { useEffect, useState } from "react";
import { useTable, usePagination } from "react-table";
import { toast } from "react-toastify";
import SummaryApi from "../common";
import { useNavigate } from "react-router-dom";
import {
  FaUserGraduate,
  FaCalendarCheck,
  FaStar,
  FaRegFrown,
  FaRegFrownOpen,
  FaRocketchat,
} from "react-icons/fa";
import { GrAnnounce } from "react-icons/gr";
import Modal from "react-modal";
import { Pie, Line, Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  ArcElement,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import nodata from '../assest/nodata.png'
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  PointElement,
  LineElement,
  ArcElement,
  Title,
  Tooltip,
  Legend
);

// Set the app element for react-modal
Modal.setAppElement("#root"); // or whichever element your app mounts to

const Dashboard = () => {
  const navigate = useNavigate();
  const [overallCounts, setOverallCounts] = useState({
    totalStudents: 0,
    studentsCreatedToday: 0,
    interested: 0,
    notInterested: 0,
    mostInterested: 0,
    interestedAddedToday: 0,
    notInterestedAddedToday: 0,
    mostInterestedAddedToday: 0,
  });
  const [studentData, setStudentData] = useState([]);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [selectedStudent, setSelectedStudent] = useState(null);
  const [memberType, setMemberType] = useState(null);
  const [employeeId, setEmployeeId] = useState(null);
  const [enrollmentData, setEnrollmentData] = useState({});
  const [callStatusCounts, setCallStatusCounts] = useState({});
  const [loading, setLoading] = useState(true);
  const [remainders, setRemainders] = useState([]);

  useEffect(() => {
    const fetchDashboardData = async () => {
      try {
        const encodedMemberType = sessionStorage.getItem("K3M8X1JQ5VZ4B7PWTL9");
        const memberType = encodedMemberType ? atob(encodedMemberType) : null;
        setMemberType(memberType);

        let currentEmployeeId = null;

        let response;
        let todayResponse;

        if (memberType === "Admin" || memberType === "Manager") {
          response = await fetch(SummaryApi.dashboardcounts.url, {
            method: SummaryApi.dashboardcounts.method,
            headers: {
              Authorization: "Bearer sandeep_university_916",
              "Content-Type": "application/json",
            },
          });

          todayResponse = await fetch(SummaryApi.todaystudents.url, {
            method: SummaryApi.todaystudents.method,
            headers: {
              Authorization: "Bearer sandeep_university_916",
              "Content-Type": "application/json",
            },
          });
        } else if (memberType === "Team Lead") {
          const encodedTeamLeadId = sessionStorage.getItem(
            "H7Z4L9VD2XK5JW8QRYT6"
          );
          if (!encodedTeamLeadId) {
            throw new Error("Team Lead ID not found in session storage");
          }
          currentEmployeeId = atob(encodedTeamLeadId);
          setEmployeeId(currentEmployeeId);

          response = await fetch(SummaryApi.getTLEmpCountByTLId.url, {
            method: SummaryApi.getTLEmpCountByTLId.method,
            headers: {
              Authorization: "Bearer sandeep_university_916",
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ team_lead_emp_id: currentEmployeeId }),
          });

          todayResponse = await fetch(
            SummaryApi.todayenrolledStudentByEmpId.url,
            {
              method: SummaryApi.todayenrolledStudentByEmpId.method,
              headers: {
                Authorization: "Bearer sandeep_university_916",
                "Content-Type": "application/json",
              },
              body: JSON.stringify({ team_lead_emp_id: currentEmployeeId }),
            }
          );
        } else {
          const encodedEmployeeId = sessionStorage.getItem(
            "H7Z4L9VD2XK5JW8QRYT6"
          );
          if (!encodedEmployeeId) {
            throw new Error("Employee ID not found in session storage");
          }
          currentEmployeeId = atob(encodedEmployeeId);
          setEmployeeId(currentEmployeeId);

          response = await fetch(SummaryApi.dashboardcountsById.url, {
            method: SummaryApi.dashboardcountsById.method,
            headers: {
              Authorization: "Bearer sandeep_university_916",
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ employee_id: currentEmployeeId }),
          });

          todayResponse = await fetch(SummaryApi.todaystudentsById.url, {
            method: SummaryApi.todaystudentsById.method,
            headers: {
              Authorization: "Bearer sandeep_university_916",
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ employee_id: currentEmployeeId }),
          });
        }

        if (!response.ok) {
          throw new Error("Failed to fetch data from the endpoint");
        }

        const data = await response.json();
        const todayStudentsData = await todayResponse.json();
        const dashboardData = data?.data || {};

        setOverallCounts({
          totalStudents: parseInt(dashboardData.total_students, 10) || 0,
          studentsCreatedToday:
            parseInt(dashboardData.today_student_count, 10) || 0,
          interested: parseInt(dashboardData.total_interested_count, 10) || 0,
          notInterested:
            parseInt(dashboardData.total_not_interested_count, 10) || 0,
          mostInterested:
            parseInt(dashboardData.total_most_interested_count, 10) || 0,
          interestedAddedToday:
            parseInt(dashboardData.today_interested_count, 10) || 0,
          notInterestedAddedToday:
            parseInt(dashboardData.today_not_interested_count, 10) || 0,
          mostInterestedAddedToday:
            parseInt(dashboardData.today_most_interested_count, 10) || 0,
        });

        setCallStatusCounts({
          Contacted: parseInt(dashboardData.total_contacted_count, 10) || 0,
          "Not Answered":
            parseInt(dashboardData.total_not_answered_count, 10) || 0,
        });

        let processedStudentData = todayStudentsData?.data || [];

        if (memberType === "Team Lead" && currentEmployeeId) {
          const today = new Date().toISOString().split("T")[0];

          // Filter for only 'Interested' students for Team Lead
          processedStudentData = processedStudentData.filter(
            (student) => student.is_interested === "Interested"
          );

          const studentsWithFollowUpStatus = await Promise.all(
            processedStudentData.map(async (student) => {
              let followedUpByTLToday = false;
              if (student.tl_student_followup_id) {
                const followUpResponse = await fetch(
                  SummaryApi.getStudentFollowDetails.url,
                  {
                    method: SummaryApi.getStudentFollowDetails.method,
                    headers: {
                      "Content-Type": "application/json",
                      Authorization: "Bearer sandeep_university_916",
                    },
                    body: JSON.stringify({
                      tl_student_followup_id: student.tl_student_followup_id,
                    }),
                  }
                );
                const followUpDetails = await followUpResponse.json();

                if (followUpDetails.status && followUpDetails.data) {
                  followedUpByTLToday = followUpDetails.data.some(
                    (followUp) =>
                      followUp.employee_id === currentEmployeeId &&
                      followUp.created_date.startsWith(today)
                  );
                }
              }
              return { ...student, followedUpByTLToday };
            })
          );
          processedStudentData = studentsWithFollowUpStatus;
        }

        setStudentData(processedStudentData);
        calculateEnrollmentData(processedStudentData);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };

    const fetchRemainders = async () => {
      const encodedEmployeeId = sessionStorage.getItem(
        "H7Z4L9VD2XK5JW8QRYT6"
      );
      if (!encodedEmployeeId) {
        toast.error("Employee ID not found. Please log in again.");
        setLoading(false);
        return;
      }
      const teamLeadEmpId = atob(encodedEmployeeId);
      try {
        const response = await fetch(SummaryApi.TlRemainders.url, {
          method: "POST",
          headers: {
            Authorization: "Bearer sandeep_university_916",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ team_lead_emp_id: teamLeadEmpId }),
        });

        const data = await response.json();
        if (data.status) {
          const today = new Date();
          today.setHours(0, 0, 0, 0); // Set to start of today

          const filteredRemainders = data.data.filter((remainder) => {
            if (!remainder.next_followup_date_time) return false;
            const reminderDate = new Date(remainder.next_followup_date_time);
            reminderDate.setHours(0, 0, 0, 0); // Set to start of reminder date

            return reminderDate.getTime() === today.getTime();
          });
          setRemainders(filteredRemainders);
        } else {
          toast.info("No remainders found for the Team Lead.");
        }
      } catch (err) {
        console.error("Failed to fetch remainders:", err);
        toast.error("Failed to fetch remainders.");
      }
    };

    fetchDashboardData();
    if (memberType === "Team Lead") {
      fetchRemainders();
    }
  }, [memberType]);

  const calculateEnrollmentData = (students) => {
    const enrollments = {};
    const today = new Date();
    const oneMonthAgo = new Date();
    oneMonthAgo.setDate(today.getDate() - 30);

    students.forEach((student) => {
      const enrollmentDate = new Date(student.created_date);
      if (enrollmentDate >= oneMonthAgo && enrollmentDate <= today) {
        const dateString = enrollmentDate.toISOString().split("T")[0];
        enrollments[dateString] = (enrollments[dateString] || 0) + 1;
      }
    });

    setEnrollmentData(enrollments);
  };

  const handleFollowUpClick = async (item) => {
    const studentIdToFetch = item.student_id;
    const tlStudentFollowupIdToFetch = item.tl_student_followup_id;

    if (!studentIdToFetch) {
      toast.error(
        "Student ID is missing for this entry. Cannot fetch full details."
      );
      return;
    }

    const responseDetails = await fetch(
      SummaryApi.getStudentDataByStudentId.url,
      {
        method: SummaryApi.getStudentDataByStudentId.method,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer sandeep_university_916",
        },
        body: JSON.stringify({ student_id: studentIdToFetch }),
      }
    );
    const studentData = (await responseDetails.json()).data || null;

    let followUps = [];
    if (tlStudentFollowupIdToFetch) {
      const responseFollow = await fetch(
        SummaryApi.getStudentFollowDetails.url,
        {
          method: SummaryApi.getStudentFollowDetails.method,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer sandeep_university_916",
          },
          body: JSON.stringify({
            tl_student_followup_id: tlStudentFollowupIdToFetch,
          }),
        }
      );
      const followData = await responseFollow.json();
      followUps = followData.data || [];
    }

    navigate("/my-history", {
      state: {
        student: item,
        studentDetails: studentData,
        studentFollowUps: followUps,
      },
    });
  };

  const data = React.useMemo(() => studentData, [studentData]);

  const columns = React.useMemo(() => {
    let cols = [
      {
        Header: "S.No.",
        accessor: "serial_number",
        Cell: ({ row }) => row.index + 1,
      },
    ];

    if (memberType === "Team Lead") {
      const maskMobileNumber = (number) => {
        if (!number) return "-";
        return "**********";
      };

      cols = cols.concat([
        {
          Header: "Employee Name",
          accessor: "employee_name",
          Cell: ({ value }) => (
            <span className="font-bold text-gray-800">{value}</span>
          ),
        },
        {
          Header: "Student Name",
          accessor: "student_name",
        },
        {
          Header: "Mobile",
          accessor: "mobile_number1",
          Cell: ({ value }) => <span>{value || "N/A"}</span>,
        },
        {
          Header: "Enrollment Code",
          accessor: "enrollment_code",
        },
        {
          Header: "Status",
          accessor: "is_interested",
          Cell: ({ value }) => {
            let colorClass = "text-gray-600";
            if (value === "Most Interested") {
              colorClass = "text-green-600";
            } else if (value === "Interested") {
              colorClass = "text-yellow-500";
            } else if (value === "Not Interested") {
              colorClass = "text-red-600";
            }
            return (
              <span className={`font-semibold ${colorClass}`}>{value}</span>
            );
          },
        },
        {
          Header: "View",
          Cell: ({ row }) => (
            <button
              onClick={() => openModal(row.original)}
              className="bg-blue-500 text-white px-2 py-1 rounded hover:bg-blue-600"
            >
              View
            </button>
          ),
        },
        {
          Header: "Follow up",
          Cell: ({ row }) => (
            <button
              onClick={() => handleFollowUpClick(row.original)}
              className="bg-blue-500 text-white px-2 py-1 rounded hover:bg-blue-600"
            >
              Follow up
            </button>
          ),
        },
      ]);
    } else {
      cols = cols.concat([
        memberType === "Admin" && {
          Header: "Employee Name",
          accessor: "employee_name",
        },
        {
          Header: "Enrollment Code",
          accessor: "enrollment_code",
        },
        {
          Header: "Student Name",
          accessor: "student_name",
        },
        {
          Header: "Mobile",
          accessor: "mobile_number1",
        },
        {
          Header: "Call Duration (HH:MM:SS)",
          accessor: "call_duration",
          Cell: ({ value }) => {
            if (value === "n/a") {
              return value;
            }
            if (value && value.includes(":")) {
              const [timePart] = value.split(".");
              const [hours, minutes, seconds] = timePart.split(":");
              return `${hours.padStart(2, "0")}:${minutes.padStart(
                2,
                "0"
              )}:${seconds.padStart(2, "0")}`;
            }
            return value;
          },
        },
        {
          Header: "Enrolled Date",
          accessor: "created_date",
          Cell: ({ value }) => new Date(value).toLocaleDateString("en-IN"),
        },
        {
          Header: "Status",
          accessor: "is_interested",
          Cell: ({ value }) => {
            let colorClass = "text-gray-600";
            if (value === "Most Interested") {
              colorClass = "text-green-600";
            } else if (value === "Interested") {
              colorClass = "text-yellow-500";
            } else if (value === "Not Interested") {
              colorClass = "text-red-600";
            }
            return (
              <span className={`font-semibold ${colorClass}`}>{value}</span>
            );
          },
        },
        {
          Header: "View",
          Cell: ({ row }) => (
            <button
              onClick={() => openModal(row.original)}
              className="bg-blue-500 text-white px-2 py-1 rounded hover:bg-blue-600"
            >
              View
            </button>
          ),
        },
      ]);
    }
    return cols.filter(Boolean);
  }, [memberType]);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    state: { pageIndex, pageSize },
    gotoPage,
    nextPage,
    previousPage,
    canPreviousPage,
    canNextPage,
    setPageSize,
    page,
    pageCount,
  } = useTable(
    {
      columns,
      data,
      initialState: { pageSize: 5 },
    },
    usePagination
  );

  const openModal = (student) => {
    setSelectedStudent(student);
    setModalIsOpen(true);
  };

  const closeModal = () => {
    setModalIsOpen(false);
    setSelectedStudent(null);
  };

  const pieData = {
    labels: ["Interested", "Not Interested", "Most Interested"],
    datasets: [
      {
        data: [
          overallCounts.interested,
          overallCounts.notInterested,
          overallCounts.mostInterested,
        ],
        backgroundColor: ["#36A2EB", "#FF6384", "#FF9F40"],
      },
    ],
  };

  const sortedDates = Object.keys(enrollmentData).sort(
    (a, b) => new Date(a) - new Date(b)
  );

  const sortedData = sortedDates.map((date) => enrollmentData[date]);

  const lineData = {
    labels: sortedDates,
    datasets: [
      {
        label: "Daily Enrollments",
        data: sortedData,
        fill: true,
        backgroundColor: "rgba(153, 102, 255, 0.2)",
        borderColor: "rgba(153, 102, 255, 1)",
        tension: 0.1,
      },
    ],
  };

  const barData = {
    labels: Object.keys(callStatusCounts),
    datasets: [
      {
        label: "Call Status Count",
        data: Object.values(callStatusCounts),
        backgroundColor: "rgba(75, 192, 192, 0.6)",
        borderColor: "rgba(75, 192, 192, 1)",
        borderWidth: 1,
      },
    ],
  };

  return (
    <div className="md:p-6 p-4 min-h-screen">
      {loading ? (
        <div className="fixed inset-0 bg-black bg-opacity-70 z-20 flex justify-center items-center">
          <span className="text-white text-lg">Fetching Data...</span>
        </div>
      ) : (
        <>
          <div>
            <h1 className="text-2xl font-bold mb-6 text-gray-800">
              <span className="text-red-600">GHRAISONI UNIVERSITY</span>
              /Dashboard
            </h1>
  
            {/* Summary Section */}
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
        <div className="bg-gradient-to-b from-blue-400 to-blue-700 p-4 rounded-lg shadow-lg flex items-center">


                <FaUserGraduate className="text-white text-3xl mr-4" />
                <div>
                  <h3 className="text-lg font-semibold text-white">
                    Total Students Enrolled
                  </h3>
                  <p className="text-xl font-bold text-white">
                    {overallCounts.totalStudents}
                  </p>
                </div>
              </div>

              <div className="bg-yellow-100 p-4 rounded-lg shadow-lg flex items-center">
                <FaStar className="text-yellow-600 text-3xl mr-4" />
                <div>
                  <h3 className="text-lg font-semibold text-yellow-700">
                    Total Interested Students
                  </h3>
                  <p className="text-xl font-bold text-yellow-800">
                    {overallCounts.interested}
                  </p>
                </div>
              </div>
              <div className="bg-gray-100 p-4 rounded-lg shadow-lg flex items-center">
                <FaRegFrown className="text-gray-600 text-3xl mr-4" />
                <div>
                  <h3 className="text-lg font-semibold text-gray-700">
                    Total Not Interested Students
                  </h3>
                  <p className="text-xl font-bold text-gray-800">
                    {overallCounts.notInterested}
                  </p>
                </div>
              </div>

              <div className="bg-teal-100 p-4 rounded-lg shadow-lg flex items-center">
                <FaStar className="text-teal-600 text-3xl mr-4" />
                <div>
                  <h3 className="text-lg font-semibold text-teal-700">
                    Total Most Interested Students
                  </h3>
                  <p className="text-xl font-bold text-teal-800">
                    {overallCounts.mostInterested}
                  </p>
                </div>
              </div>

              <div className="bg-green-100 p-4 rounded-lg shadow-lg flex items-center">
                <FaCalendarCheck className="text-green-600 text-3xl mr-4" />
                <div>
                  <h3 className="text-lg font-semibold text-green-700">
                    Students Enrolled Today
                  </h3>
                  <p className="text-xl font-bold text-green-800">
                    {overallCounts.studentsCreatedToday}
                  </p>
                </div>
              </div>

              <div className="bg-red-100 p-4 rounded-lg shadow-lg flex items-center">
                <FaStar className="text-red-600 text-3xl mr-4" />
                <div>
                  <h3 className="text-lg font-semibold text-red-700">
                    Interested Students Enrolled Today
                  </h3>
                  <p className="text-xl font-bold text-red-800">
                    {overallCounts.interestedAddedToday}
                  </p>
                </div>
              </div>

              <div className="bg-purple-100 p-4 rounded-lg shadow-lg flex items-center">
                <FaRegFrownOpen className="text-purple-600 text-3xl mr-4" />
                <div>
                  <h3 className="text-lg font-semibold text-purple-700">
                    Not Interested Added Today
                  </h3>
                  <p className="text-xl font-bold text-purple-800">
                    {overallCounts.notInterestedAddedToday}
                  </p>
                </div>
              </div>

              <div className="bg-indigo-100 p-4 rounded-lg shadow-lg flex items-center">
                <FaRocketchat className="text-indigo-600 text-3xl mr-4" />
                <div>
                  <h3 className="text-lg font-semibold text-indigo-700">
                    Most Interested Added Today
                  </h3>
                  <p className="text-xl font-bold text-indigo-800">
                    {overallCounts.mostInterestedAddedToday}
                  </p>
                </div>
              </div>
            </div>
      {/* Team Lead Reminders Section */}
            {memberType === "Team Lead" && (
              <div className="bg-white border p-4 rounded-lg shadow-lg mb-6">
                <div className="flex justify-between">
                  <h2 className="text-lg font-semibold mb-2 text-blue-700 flex items-center">
                    <span className="mt-2 pr-2">
                      <GrAnnounce />{" "}
                    </span>{" "}
                    {remainders.length > 0
                      ? "Today Remainders "
                      : "No Remainders for Today"}
                  </h2>
                  <button
                    className="bg-blue-500 text-white px-2 py-1 rounded hover:bg-blue-600 mb-2"
                    onClick={() => navigate("/tl-remainders")}
                  >
                    View All
                  </button>
                </div>
                <div className="overflow-x-auto">
                  {remainders.length > 0 ? (
                    <table className="min-w-full bg-white">
                      <thead>
                        <tr className="bg-gray-200 text-gray-600">
                          <th className="py-2 px-4 border-b text-left text-sm font-medium">
                            S.No.
                          </th>
                          <th className="py-2 px-4 border-b text-left text-sm font-medium">
                            Student Name
                          </th>
                          <th className="py-2 px-4 border-b text-left text-sm font-medium">
                            Mobile Number
                          </th>
                          <th className="py-2 px-4 border-b text-left text-sm font-medium">
                            Next Follow-up Date/Time
                          </th>
                          <th className="py-2 px-4 border-b text-left text-sm font-medium">
                            Description
                          </th>
                          <th className="py-2 px-4 border-b text-left text-sm font-medium">
                            Actions
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {remainders.slice(0, 10).map((remainder, index) => (
                          <tr
                            key={index}
                            className="border-b hover:bg-gray-50"
                          >
                            <td className="py-2 px-4 text-sm">{index + 1}</td>
                            <td className="py-2 px-4 text-sm">
                              {remainder.student_name}
                            </td>
                       <td className="py-2 px-4 text-sm">
  {remainder.mobile_number1 || "N/A"}
</td>
                            <td className="py-2 px-4 text-sm">
                              {remainder.next_followup_date_time
                                ? new Date(
                                    remainder.next_followup_date_time
                                  ).toLocaleString()
                                : "N/A"}
                            </td>
                            <td className="py-2 px-4 text-sm">
                              {remainder.lead_description || "N/A"}
                            </td>
                            <td className="py-2 px-4 text-sm">
                              <button
                                onClick={() => handleFollowUpClick(remainder)}
                                className="bg-blue-500 text-white px-2 py-1 rounded hover:bg-blue-600"
                              >
                                Follow up remainder
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  ) : (
                    <p className="text-center py-4 text-red-600 font-bold">
                      <div className="flex items-center justify-center mb-2">
  <img src={nodata} alt="No data" className="max-w-full h-auto" />
</div>

                      No remainders scheduled for today.
                    </p>
                  )}
                </div>
              </div>
            )}
            <div className="bg-white border p-4 rounded-lg shadow-lg mb-6">
              <h2 className="text-lg font-semibold mb-2 text-gray-700">
                Today Enrolled Student Details
              </h2>
              <div className="overflow-x-auto">
                <table
                  {...getTableProps()}
                  className="min-w-full bg-white mb-4"
                >
                  <thead>
                    {headerGroups.map((headerGroup) => (
                      <tr
                        {...headerGroup.getHeaderGroupProps()}
                        className="bg-gray-200 text-gray-600"
                      >
                        {headerGroup.headers.map((column) => (
                          <th
                            {...column.getHeaderProps()}
                            className="py-2 px-4 border-b text-left text-sm font-medium"
                          >
                            {column.render("Header")}
                          </th>
                        ))}
                      </tr>
                    ))}
                  </thead>
                  <tbody {...getTableBodyProps()}>
                    {page.length > 0 ? (
                      page.map((row) => {
                        prepareRow(row);
                        const rowClass =
                          memberType === "Team Lead" &&
                          row.original.followedUpByTLToday
                            ? "bg-green-100 hover:bg-green-200"
                            : "hover:bg-gray-50";
                        return (
                          <tr
                            {...row.getRowProps()}
                            className={`border-b ${rowClass}`}
                          >
                            {row.cells.map((cell) => (
                              <td
                                {...cell.getCellProps()}
                                className="py-2 px-4 text-sm"
                              >
                                {cell.render("Cell")}
                              </td>
                            ))}
                          </tr>
                        );
                      })
                    ) : (
                      <tr>
                        <td
                          colSpan={columns.length}
                          className="text-center py-2 text-gray-600"
                        >
                          No students found for today.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>

                <div className="flex justify-between items-center mb-4">
                  <span>
                    Page {pageIndex + 1} of {pageCount} of{" "}
                    {overallCounts.studentsCreatedToday} entries
                  </span>
                  <div>
                    <button
                      onClick={() => gotoPage(0)}
                      disabled={!canPreviousPage}
                      className="px-3 py-1 border rounded"
                    >
                      {"<<"}
                    </button>
                    <button
                      onClick={previousPage}
                      disabled={!canPreviousPage}
                      className="px-3 py-1 border rounded"
                    >
                      {"<"}
                    </button>
                    <button
                      onClick={nextPage}
                      disabled={!canNextPage}
                      className="px-3 py-1 border rounded"
                    >
                      {">"}
                    </button>
                    <button
                      onClick={() => gotoPage(pageCount - 1)}
                      disabled={!canNextPage}
                      className="px-3 py-1 border rounded"
                    >
                      {">>"}
                    </button>
                  </div>
                  <select
                    value={pageSize}
                    onChange={(e) => {
                      setPageSize(Number(e.target.value));
                    }}
                    className="ml-4 border rounded"
                  >
                    {[5, 10, 20, 50, 100].map((pageSize) => (
                      <option key={pageSize} value={pageSize}>
                        Show {pageSize}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>

      

            {/* Charts Section */}
            <div className="flex flex-wrap justify-between">
              <div className="my-6 w-full md:w-1/2 p-2">
                <h2 className="text-xl font-bold text-center text-blue-600">
                  Call Status Distribution
                </h2>
                <div className="flex justify-center">
                  <div className="h-96 w-full max-w-2xl">
                    <Bar
                      data={barData}
                      options={{
                        maintainAspectRatio: false,
                        responsive: true,
                        plugins: {
                          legend: {
                            position: "top",
                          },
                        },
                        scales: {
                          y: {
                            beginAtZero: true,
                          },
                        },
                      }}
                    />
                  </div>
                </div>
              </div>

              <div className="my-6 w-full md:w-1/2 p-2">
                <h2 className="text-xl font-bold text-center text-blue-600">
                  Not Interested vs. Interested vs. Most Interested Students
                </h2>
                <div className="flex justify-center">
                  <div className="h-96 w-full max-w-md">
                    <Pie
                      data={pieData}
                      options={{
                        maintainAspectRatio: false,
                        responsive: true,
                        plugins: {
                          legend: {
                            position: "top",
                          },
                        },
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>

            {/* Modal for Student Details */}
            <Modal
              isOpen={modalIsOpen}
              onRequestClose={closeModal}
              contentLabel="Student Details"
              className="mx-auto flex flex-col my-10 max-h-[80vh] mt-[100px] max-w-[30%] bg-white rounded-lg shadow-lg overflow-auto"
              overlayClassName="fixed inset-0 bg-black bg-opacity-50"
            >
              <div className="sticky top-0 z-10 bg-gray-100 border-b border-gray-300 px-8 py-4">
                <div className="flex justify-between items-center">
                  <h2 className="text-2xl font-semibold text-gray-800">
                    Student Details
                  </h2>
                  <button
                    onClick={closeModal}
                    className="text-gray-600 hover:text-gray-800 text-2xl"
                  >
                    &times;
                  </button>
                </div>
              </div>
              <div className="p-8">
                {selectedStudent && (
                  <div className="space-y-4">
                    <div className="flex justify-between">
                      <span className="font-semibold text-gray-700">
                        Enrollment Code:
                      </span>
                      <span className="text-gray-600">
                        {selectedStudent.enrollment_code}
                      </span>
                    </div>
                    <div className="flex justify-between">
                      <span className="font-semibold text-gray-700">
                        Student Name:
                      </span>
                      <span className="text-gray-600">
                        {selectedStudent.student_name}
                      </span>
                    </div>
                    <div className="flex justify-between">
                      <span className="font-semibold text-gray-700">
                        Gender:
                      </span>
                      <span className="text-gray-600">
                        {selectedStudent.gender}
                      </span>
                    </div>
                    <div className="flex justify-between">
                      <span className="font-semibold text-gray-700">
                        Father's Name:
                      </span>
                      <span className="text-gray-600">
                        {selectedStudent.father_name}
                      </span>
                    </div>
                    <div className="flex justify-between">
                      <span className="font-semibold text-gray-700">
                        Mobile Number 1:
                      </span>
                      <span className="text-gray-600">
                        {selectedStudent.mobile_number1}
                      </span>
                    </div>
                    <div className="flex justify-between">
                      <span className="font-semibold text-gray-700">
                        Mobile Number 2:
                      </span>
                      <span className="text-gray-600">
                        {selectedStudent.mobile_number2 || "N/A"}
                      </span>
                    </div>
                    <div className="flex justify-between">
                      <span className="font-semibold text-gray-700">
                        Email:
                      </span>
                      <span className="text-gray-600">
                        {selectedStudent.email}
                      </span>
                    </div>

                    <div className="flex justify-between">
                      <span className="font-semibold text-gray-700">
                        Aadhar Number:
                      </span>
                      <span className="text-gray-600">
                        {selectedStudent.aadhar_number}
                      </span>
                    </div>
                    <div className="flex justify-between">
                      <span className="font-semibold text-gray-700">
                        State:
                      </span>
                      <span className="text-gray-600">
                        {selectedStudent.state}
                      </span>
                    </div>
                    <div className="flex justify-between">
                      <span className="font-semibold text-gray-700">
                        District:
                      </span>
                      <span className="text-gray-600">
                        {selectedStudent.district}
                      </span>
                    </div>
                    <div className="flex justify-between">
                      <span className="font-semibold text-gray-700">
                        City:
                      </span>
                      <span className="text-gray-600">
                        {selectedStudent.city}
                      </span>
                    </div>
                    <div className="flex justify-between">
                      <span className="font-semibold text-gray-700">
                        Address:
                      </span>
                      <span className="text-gray-600">
                        {selectedStudent.address}
                      </span>
                    </div>
                    <div className="flex justify-between">
                      <span className="font-semibold text-gray-700">
                        Pincode:
                      </span>
                      <span className="text-gray-600">
                        {selectedStudent.pincode}
                      </span>
                    </div>
                    <div className="flex justify-between">
                      <span className="font-semibold text-gray-700">
                        Course:
                      </span>
                      <span className="text-gray-600">
                        {selectedStudent.course}
                      </span>
                    </div>
                    <div className="flex justify-between">
                      <span className="font-semibold text-gray-700">
                        College:
                      </span>
                      <span className="text-gray-600">
                        {selectedStudent.clg_name}
                      </span>
                    </div>
                    <div className="flex justify-between">
                      <span className="font-semibold text-gray-700">
                        Intermediate Percentage/CGPA:
                      </span>
                      <span className="text-gray-600">
                        {selectedStudent.inter_percentage}
                      </span>
                    </div>
                    <div className="flex justify-between">
                      <span className="font-semibold text-gray-700">
                        Program Type:
                      </span>
                      <span className="text-gray-600">
                        {selectedStudent.program_type}
                      </span>
                    </div>
                    <div className="flex justify-between">
                      <span className="font-semibold text-gray-700">
                        UG/PG Course:
                      </span>
                      <span className="text-gray-600">
                        {selectedStudent.ug_pg_course}
                      </span>
                    </div>
                    <div className="flex justify-between">
                      <span className="font-semibold text-gray-700">
                        Call Status:
                      </span>
                      <span className="text-gray-600">
                        {selectedStudent.call_status}
                      </span>
                    </div>
                    <div className="flex justify-between">
                      <span className="font-semibold text-gray-700">
                        Call Duration:
                      </span>
                      <span className="text-gray-600">
                        {selectedStudent.call_duration.split(".")[0]}
                      </span>
                    </div>
                    <div className="flex justify-between">
                      <span className="font-semibold text-gray-700">
                        Remarks:
                      </span>
                      <span className="text-gray-600">
                        {selectedStudent.remarks}
                      </span>
                    </div>
                    <div className="flex justify-between">
                      <span className="font-semibold text-gray-700">
                        Status:
                      </span>
                      <span
                        className={`${
                          selectedStudent.is_interested === "Most Interested"
                            ? "font-semibold text-green-600"
                            : selectedStudent.is_interested === "Interested"
                            ? "font-semibold text-yellow-500"
                            : selectedStudent.is_interested === "Not Interested"
                            ? "font-semibold text-red-600"
                            : "text-gray-600"
                        }`}
                      >
                        {selectedStudent.is_interested}
                      </span>
                    </div>
                  </div>
                )}
              </div>
            </Modal>
          </div>
        </>
      )}
    </div>
  );
};

export default Dashboard;